import React, { Component } from "react";
import { navigate } from "../../store/navigation/operations";
import { connect } from "react-redux";
import UserBookingHistory from "../../components/UserBookingHistory";
import { Callout, Icon, Button } from "@blueprintjs/core";
import { DateRangePicker } from "@blueprintjs/datetime";
import LoadingIndicator from "../../components/LoadingIndicator";
import { fetchBookings, addBooking, deleteBooking } from "../../store/booking/operations";
import {
  getBookingsForProduct,
  isBookingSending,
  isBookingFetching,
  isBookingDeleting,
  userBookings,
  getSelectedIntervals
} from "../../store/booking/selectors";
import moment from "moment";
import UserDecorator from "../../containers/UserDecorator";
import { loggedInUserGuid } from "../../store/iam/selectors";
import { getCircleWithId, isPrylpoolenCircle } from "../../store/my_circles/selectors";
import { BookingDetails } from "../../components/BookingDetails";
import { DateUtils } from "react-day-picker";
import { Translate } from "react-redux-i18n";
import MomentLocaleUtils from "react-day-picker/moment";
import { pushNotification } from "../../store/ui_notifications/creators";
import { isBookingAllowed, convertDateToUTC } from "../../utils/utils";
import { OLD_BOOKINGS_END_TIME } from '../../config'
import BookingLimitationInfo from "../../components/BookingLimitationsInfo/BookingLimitationInfo";
class Booking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_info: true,
      showBookingDetails: false,
      showTimeSelectorModal: false,
      bookings: [],
      from: undefined,
      to: undefined,
    };

    this.intervalId = undefined;
    this.modifiers = { past: { before: new Date() } };
    this.modifiersStyles = {
      past: {
        color: "#dce0e0",
      },
    };
    this.calendarMaxDate = moment().add(1, 'year').toDate()
  }

  componentDidMount() {
    let start_time = moment().subtract(1, 'month');
    start_time = new Date(Date.UTC(start_time.year(), start_time.month(), start_time.date(), 0, 0, 0, 0)).getTime();

    this.props.fetchBookings(this.props.productId, { start_time, isRental: this.props.isRental });
    if (!this.intervalId) {
      this.intervalId = setInterval(this.refresh, 30000);
    }
  }

  refresh = () => {
    let start_time = moment();
    start_time = new Date(Date.UTC(start_time.year(), start_time.month(), start_time.date(), 0, 0, 0, 0)).getTime();
    this.props.fetchBookings(this.props.productId, { start_time, isRental: this.props.isRental });
  };

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  saveBooking = (dates) => {
    if (!isBookingAllowed(dates[0], dates[1], this.props.bookings)) {
      this.props.pushNotification("booking.overlapping_interval", "error");
    } else {

      let start_time = moment(dates[0]);
      let end_time = moment(dates[1]);
      if (this.props.isRental) {
        let url = `/rentals-checkout?start_time=${start_time.format('YYYY-MM-DDTHH:mm:ss')}&end_time=${end_time.format('YYYY-MM-DDTHH:mm:ss')}&circle_guid=${this.props.circleId}`;
        if (this.props.successUrl) {
          url += `&success_url=${this.props.successUrl}`;
        }
        this.props.navigate(url);
      } else {
        this.props.addBooking(
          {
            product_guid: this.props.productId,
            circle_guid: this.props.circleId,
            start_time: moment(start_time).format("YYYY-MM-DD HH:mm"),
            end_time: moment(end_time).format("YYYY-MM-DD HH:mm"),
          },
          this.props.myGuid
        )
          .then((_) => {
            this.handleOnClose();
          });
      }
    }
  };

  deleteBooking = (booking) => {
    this.props.deleteBooking(booking).then((_) => {
      this.setState({
        showBookingDetails: false,
        from: undefined,
      });
    });
  };

  handleOnClose = () => {
    this.setState({
      showBookingDetails: false,
      showTimeSelectorModal: false,
      from: undefined,
      to: undefined,
    });
  };

  onDayClick = (day, modifier, e) => {
    let past_date = false;
    if (modifier.past) {
      past_date = true
    }
    const range = DateUtils.addDayToRange(day, this.state);
    const bookings_details = this.searchBookingDetails(day);

    if (past_date && bookings_details.length === 0) {
      return false
    }

    this.setState({
      ...range,
      past_date,
      bookings: bookings_details,
      showBookingDetails: true
    });
  };

  searchBookingDetails = (date) => {
    const current_day = moment.utc(date).clone();
    const bookings = this.props.bookings.filter((booking) => {
      const from = convertDateToUTC(new Date(booking.start_time));
      const to = convertDateToUTC(new Date(booking.end_time));
      const start = moment(from);
      const end = moment(to);

      if (start.isSame(current_day, "day") && end.isSame(current_day, "day")) {
        return true;
      }

      let comparison_rule = "[]";
      if (end.hour() === 0 && end.minute() === 0) {
        comparison_rule = "[)";
      }
      if (booking.created_at < OLD_BOOKINGS_END_TIME) {   //to be deleted after OLD_BOOKINGS_END_TIME
        comparison_rule = "[]";
      }
      const is_between = current_day.isBetween(booking.start_time, booking.end_time, "day", comparison_rule);
      return is_between;
    });
    return bookings;
  };

  render() {
    const modifiers = {
      ...this.modifiers,
      ...this.props.selected_intervals.modifiers,
      ...this.props.selected_intervals.users,
    };
    const modifiersStyles = { ...this.modifiersStyles, ...this.props.selected_intervals.modifiersStyles };
    const disableBooking = !this.props.isRental && this.props.is_prylpoolen && (this.props.circle.status !== 'completed');

    return (
      <>
        {!this.props.circle && <LoadingIndicator />}
        {this.props.circle && (
          <>

            <div className={`booking-calendar ${disableBooking ? 'disable-booking-click' : ''}`} >
              {!this.props.isRental && this.state.show_info && (
                <Callout icon="info-sign" intent="primary" className="dismissable-note">
                  <Translate value="booking.select_period" />
                  <Button className="dismiss-note small" onClick={(_) => this.setState({ show_info: false })}>
                    <Icon icon="cross" iconSize="16" className="icon" />
                  </Button>
                </Callout>
              )}
              {!this.props.isRental && this.props.is_prylpoolen && <BookingLimitationInfo circle={this.props.circle} />}
              {!this.props.bookings && this.props.fetching_bookings && <LoadingIndicator />}
              <DateRangePicker
                className="hide"
                shortcuts={false}
                singleMonthOnly={true}
                allowSingleDayRange={true}
                // onChange={this.dateSelected}
                modifiers={modifiers}
                modifiersStyles={modifiersStyles}
                value={[this.state.from, this.state.to]}
                locale={this.props.locale}
                maxDate={this.calendarMaxDate}
                dayPickerProps={{
                  onDayClick: this.onDayClick,
                  // disabledDays: this.isDisabledDate,
                  modifiersStyles: modifiersStyles,
                  localeUtils: MomentLocaleUtils,
                }}
              />
            </div>
            {!this.props.isRental && !this.props.is_prylpoolen &&
              <div className="user-list booking">
                {this.props.circle.members.map((member) => (
                  <UserDecorator key={member} userId={member}>
                    <UserBookingHistory
                      user_bookings={userBookings(this.props.bookings, member)}
                      bookings={this.props.bookings}
                    />
                  </UserDecorator>
                ))}
              </div>
            }
          </>
        )}

        <BookingDetails
          past_date={this.state.past_date}
          deleting_booking={this.props.deleting_booking}
          myGuid={this.props.myGuid}
          deleteBooking={this.deleteBooking}
          isOpen={this.state.showBookingDetails}
          bookings={this.state.bookings}
          booking_stats={this.props.selected_intervals.booking_stats}
          handleOnClose={this.handleOnClose}
          selected_date={this.state.from}
          saveBooking={this.saveBooking}
          saving_booking={this.props.saving_booking}
          rentals={this.props.isRental}
          circleId={this.props.circleId}
        />
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    locale: state.i18n.locale,
    myGuid: loggedInUserGuid(state),
    bookings: getBookingsForProduct(state, props.productId, props.isRental || false),
    selected_intervals: getSelectedIntervals(state, props.productId, loggedInUserGuid(state), props.isRental || false),
    saving_booking: isBookingSending(state),
    fetching_bookings: isBookingFetching(state),
    deleting_booking: isBookingDeleting(state),
    circle: getCircleWithId(state, props.circleId),
    is_prylpoolen: isPrylpoolenCircle(state, props.circleId)
  };
};

const mapDispatchToProps = {
  fetchBookings,
  deleteBooking,
  addBooking,
  navigate,
  pushNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(Booking);
